import type { ApiClient } from '@travel/api-client';

import type { SuggestionsItem } from 'Suggestions-Types';

export type FetchOption = {
  limit?: number;
  pathIdScope?: string;
  gsp_reqId?: string;
};

export const fetch = (
  text: string,
  options: FetchOption,
  http: ApiClient,
): Promise<SuggestionsItem[]> =>
  http.get('/auto-completion/v3', {
    values: {
      ...options,
      keyword: text,
    },
  });
